// extracted by mini-css-extract-plugin
module.exports = {"button":"SubBrandTab_button__L4tYU","wrapperText":"SubBrandTab_wrapperText__vvxDA","selected":"SubBrandTab_selected__TzRJQ"};